module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-120x120.099a3c08.png";